import { render, staticRenderFns } from "./UserRegisterPackageHistory.vue?vue&type=template&id=0ccf5548&scoped=true"
import script from "./UserRegisterPackageHistory.vue?vue&type=script&lang=js"
export * from "./UserRegisterPackageHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccf5548",
  null
  
)

export default component.exports